export const PhotoService = {
	getData() {
		return [
			{
				itemImageSrc: 'photo/IMG_2961.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_3170.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_3457.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_3508.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_3703.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_3832.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_4699.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_4727.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_4794.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_4829.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_4856.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_5333.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_5635.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_6136.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
			{
				itemImageSrc: 'photo/IMG_6382.JPG',
				thumbnailImageSrc: '',
				alt: '',
				title: ''
			},
		];
	},
	getImages() {
		return Promise.resolve(this.getData());
	}
};

